
import XHeader from 'vux/src/components/x-header/index.vue'

import {mapState,mapMutations} from 'vuex'
export default {
data(){
return{
url: null
}
},
components:{
XHeader

},
computed:{
...mapState(['token'])
},
created(){
this.SETTOKEN()
this.url = this.$route.query.url
},
methods:{
...mapMutations(['SETTOKEN']),


}
}



// WEBPACK FOOTER //
// ./src/pages/rechargeIframe.vue